export const PrinterPaperSizes = {
    '58_MM': '58_MM',
    '80_MM': '80_MM',
} as const;

export type PrinterPaperSize = (typeof PrinterPaperSizes)[keyof typeof PrinterPaperSizes];
